"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistenceHandler = void 0;
const React = require("react");
const PersistenceContext_1 = require("../../contexts/PersistenceContext");
const PersistenceHandler = ({ provider, children }) => {
    // need to be arrouw function to bind the window context
    // also need to be async as RN environment is Promise based
    const handleGetItem = (key) => {
        return new Promise(res => {
            res(provider.getItem(key));
        }).catch(console.error);
    };
    const handleSetItem = (key, value) => {
        return new Promise(res => {
            res(provider.setItem(key, value));
        }).catch(console.error);
    };
    const handleRemoveItem = (key) => {
        return new Promise(res => {
            res(provider.removeItem(key));
        }).catch(console.error);
    };
    const value = {
        getItem: handleGetItem,
        setItem: handleSetItem,
        removeItem: handleRemoveItem
    };
    return (React.createElement(PersistenceContext_1.PersistenceContext.Provider, { value: value }, children));
};
exports.PersistenceHandler = PersistenceHandler;
//# sourceMappingURL=index.js.map